import { store } from '@/store';
import rejectEmployeeAccess from '../reject-employee-access/reject-employee-access';

/**
 * Reject store selection access if multistore is disabled and no stores are configured to be shown,
 * then apply the employee access rules
 * @param {*} to destination
 * @param {*} from source
 * @param {*} next next route
 */
export default async function selectStoreAccess(to, from, next) {
  if (!store.getters.getConfiguration.multistore) {
    await store.dispatch('stores/fetchStores');

    if (!store.getters['stores/hasStores']) {
      next({ name: 'Home' });
      return;
    }
  }

  await rejectEmployeeAccess(to, from, next);
}
